import { merchantActionTypes } from '../action-types';
import { BASE_URL } from '../../../../config/environmentConfig';
import { getFormattedAdminFormFields, IAgent } from '../../../constants/new-agent/new-agent-form';
import { successAlert } from '../../../components/ToastMessage';
import {
	getFormattedAgencyFormFields,
	IAgency
} from '../../../constants/new-agency/new-agency-form';
import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { GET, POST, PUT } from '../../store-helper';
import { requestErrorHandler } from '../../../utils/newApplicationUtils';

export const fetchAgencyList = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_AGENCY_LIST_LOADING, payload: true });

		const data = await GET({ pathname: `${BASE_URL.MERCHANTS}/salesAgencies` });
		let agencyList: IAgency[] = [];

		if (data) {
			agencyList = data.map((item: IAgency) => ({
				value: item.id,
				label: item.name
			}));
		}
		dispatch({ type: merchantActionTypes.FETCH_AGENCY_LIST, payload: data || [] });
		dispatch({ type: merchantActionTypes.FETCH_SALES_AGENCY_LIST_SELECTOR, payload: agencyList });

	} catch (e) {
		dispatch({ type: merchantActionTypes.FETCH_AGENCY_LIST, payload: [] });
		dispatch({ type: merchantActionTypes.FETCH_SALES_AGENCY_LIST_SELECTOR, payload: [] });
	}
};

export const setAgency = async (
	dispatch: React.Dispatch<IAction>,
	formik: any,
	agency: IAgency,
	setChosenAgency: (value: IAgency | null) => void,
	onSuccess: () => void,
	onError: () => void
): Promise<void> => {
	if (!formik.isValid) return;
	try {
		dispatch({ type: merchantActionTypes.SET_NEW_AGENCY_CREATION_LOADING, payload: true });

		const data: IAgency = getFormattedAgencyFormFields(formik.values);

		if (agency?.id) {
			data.id = agency.id;

			await PUT({
				pathname: `${BASE_URL.MERCHANTS}/SalesAgencies`,
				body: data,
				formik
			});

			setChosenAgency && setChosenAgency(null);

		} else {
			await POST({
				pathname: `${BASE_URL.MERCHANTS}/SalesAgencies`,
				body: data,
				formik
			});
		}
		onSuccess();
		await fetchAgencyList(dispatch);

	} catch (e) {
		console.log('setAgency error', e.response);

		// onError();
	} finally {
		dispatch({ type: merchantActionTypes.SET_NEW_AGENCY_CREATION_LOADING, payload: false });
	}
};

export const sentAgentInvite = async (agencyId: string): Promise<void> => {
	try {

		await POST({ pathname: `${BASE_URL.MERCHANTS}/salesAgencies/${agencyId}/invite-agent` });

		successAlert({
			title: 'Invitation was successfully sent!'
		});
	} catch (e) {
		console.log('sentAgentInvite', e);
		requestErrorHandler(e);
	}
};

export const setSalesAgent = async (
	dispatch: React.Dispatch<IAction>,
	formik: any,
	salesAgent: IAgent,
	setChosenSalesAgent: (value: IAgent) => void,
	agentRole: string,
	agencyId: string,
	onSuccess: () => void,
	onError: () => void
): Promise<void> => {
	dispatch({ type: merchantActionTypes.SET_CREATING_NEW_SALES_AGENT_LOADING, payload: true });
	if (!formik.isValid) return;
	try {
		const params = getFormattedAdminFormFields(formik.values);
		params.role = agentRole;
		if (salesAgent?.id) {
			params.id = salesAgent.id;

			await PUT({
				pathname: `${BASE_URL.MERCHANTS}/salesAgencies/${agencyId}/agent`,
				body: params,
				formik
			});
			setChosenSalesAgent(null);
		} else {

			await POST({
				pathname: `${BASE_URL.MERCHANTS}/salesAgencies/${agencyId}/agent`,
				body: params,
				formik
			});
		}
		onSuccess();
		await fetchAgencyList(dispatch);
		dispatch({ type: merchantActionTypes.SET_CREATING_NEW_SALES_AGENT_LOADING, payload: false });
	} catch (e) {
		console.log('setSalesAgent error', e.response);
		dispatch({ type: merchantActionTypes.SET_CREATING_NEW_SALES_AGENT_LOADING, payload: false });
		// onError();
	}
};
